<template>
  <v-card v-if="object" class="mb-2">
    <v-card-text>
      <v-form>
        <!-- Asunto -->
        <v-text-field
          :disabled="!editing"
          label="Asunto"
          id="Subject"
          v-model="object.subject"
        />
        <!-- Habilitado -->
        <v-switch
          :disabled="!editing"
          v-model="object.requires_acceptance"
          inset
          label="Requiere Aceptación"
        ></v-switch>
        <!-- campaña -->
        <v-autocomplete
          :disabled="!editing"
          label="Campaña"
          :items="comunicationCampaignItems"
          hide-details
          hide-no-data
          hide-selected
          item-text="code"
          item-value="url"
          v-model="object.campaign"
          ref="comunicationCampaignAutocomplete"
          prepend-icon="mdi-close"
          @click:prepend="clearAutocomplete()"
        ></v-autocomplete>
        <!-- fecha desde -->
        <v-menu
          :disabled="!editing"
          :ref="'menu_date'"
          v-model="showPicker"
          :close-on-content-click="false"
          :return-value.sync="object.date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :disabled="!editing"
              label="Fecha de Publicación desde"
              v-model="object.date_formatted"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              class="mt-4"
            ></v-text-field>
          </template>
          <v-date-picker v-model="object.date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="showPicker = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="dateEntered(object)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
        <!-- Adjunto -->
        <v-file-input
          v-show="editing"
          v-model="object.document_file"
        ></v-file-input>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "CominicationEdit",

  components: {
    //
  },

  props: {
    itemURL: {
      type: String,
      default: null
    },
    initialMode: {
      type: String,
      default: null
    }
  },

  data: () => ({
    showPicker: false,
    editing: false,
    mode: null,
    object: null,
    comunicationCampaignItems: []
  }),

  methods: {
    dateEntered(object) {
      this.$refs["menu_date"].save(object.date);
      object.date_formatted = this.formatDate(object.date);
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async beginEdit(object_url) {
      try {
        let obj = await this.$bRoot.getObjectByURL(object_url);
        if (obj) {
          obj.date_formatted = this.formatDate(obj.date);
          this.object = obj;
          // eslint-disable-next-line
          this.editing = (this.mode === "edit" || this.mode == "new");
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.$emit("endEdit");
      }
    },

    clearAutocomplete() {
      this.$refs["comunicationCampaignAutocomplete"].internalValue = [];
    },

    getNew() {
      this.object = {
        subject: null,
        campaign: null,
        requires_acceptance: false,
        document_file: null,
        date: null,
        date_formatted: null
      };
    },

    async save() {
      try {
        this.$bRoot.errors = null;
        //validate commercial_person information
        if (this.$bRoot.isNullOrEmpty(this.object, "subject")) {
          throw "El dato asunto es obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(this.object, "campaign")) {
          throw "El dato campaña es obligatorio";
        }
        if (
          this.$bRoot.isNullOrEmpty(this.object, "url") &&
          this.$bRoot.isNullOrEmpty(this.object, "document_file")
        ) {
          throw "Debe adjuntarse un documento";
        }
        if (this.$bRoot.isNullOrEmpty(this.object, "date")) {
          throw "El dato fecha desde es obligatorio";
        }
        if (!this.$bRoot.isNullOrEmpty(this.object, "document_file")) {
          if (this.object.document_file.name.length > 75) {
            throw "Longitud máxima del nombre de archivo 75 caracteres";
          }
        }
        let added = null;

        let configs = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        let formData = new FormData();
        formData.append("subject", this.object.subject);
        formData.append("campaign", this.object.campaign);
        formData.append("requires_acceptance", this.object.requires_acceptance);
        formData.append("date", this.object.date);
        if (this.object.code) {
          formData.append("code", this.object.code);
        }
        if (this.object.id) {
          formData.append("id", this.object.id);
        }
        if (this.object.document_file) {
          formData.append("document", this.object.document_file);
        }

        if (this.object.url) {
          added = await this.$bRoot.patch(formData, configs, this.object.url);
        } else {
          added = await this.$bRoot.add(
            "/data/comunications",
            null,
            formData,
            configs
          );
        }
        if (added) {
          this.$emit("endEdit");
        } else {
          throw "El registro no se guardo";
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
          return null;
        }
      }
    }
  },

  async mounted() {
    this.mode = this.initialMode;
    if (this.itemURL) {
      await this.beginEdit(this.itemURL);
    }
    // eslint-disable-next-line
    this.editing = (this.mode === "edit" || this.mode == "new");

    if (!this.object) {
      this.getNew();
    }

    //campaigns
    let campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
    this.comunicationCampaignItems = campaigns.data.results;
  }
};
</script>

<style></style>
